// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"16f20739","342":"719986e9","346":"319ea57c","507":"aadb38a8","787":"75ded5ef","808":"a3002b6a","959":"e912c4c6"}[chunkId] + ".chunk.js";
};